// extracted by mini-css-extract-plugin
export default {"DepartmentNavWrapper":"departmentNav_DepartmentNavWrapper__CBjmT","DepartmentNav":"departmentNav_DepartmentNav__xuPai","Button":"departmentNav_Button__lITuy"};